<template>
  <div>
    <!-- <a
      id="menu-toggle"
      @click="openMenu"
      href="#"
      class="btn btn-primary btn-lg toggle"
      ><i class="glyphicon glyphicon-bookmark"></i
    ></a>
    <div id="sidebar-wrapper">
      <ul class="sidebar-nav">
        <a
          id="menu-close"
          @click="openMenu"
          href="#"
          class="btn btn-default btn-lg pull-right toggle"
          ><i class="glyphicon glyphicon-remove"></i
        ></a>
        <li class="sidebar-brand">
          <a href="#">Project name</a>
        </li>
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
    </div> -->
    <div class="container-fluid">
      <div class="row">
        <!-- <vue-nested-menu :source="menu" /> -->
        <div class="col-3 sidebar">
          <div class="my-3">
            <search-input />
          </div>
          <hr />
          <h6>دسته بندی</h6>
          <multi-level-menu
            :items="categories.tree"
            v-on:select="filterCategory"
          />
        </div>

        <div class="col-9">
          <products-list-container></products-list-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsListContainer from "../products_list/ProductsListContainer";
import MultiLevelMenu from "../../components/multi-level-menu";
import SearchInput from "../../components/search/SearchInput";
import { mapGetters } from "vuex";

export default {
  name: "homepage-component",
  components: {
    "products-list-container": ProductsListContainer,
    "multi-level-menu": MultiLevelMenu,
    "search-input": SearchInput,
  },

  computed: {
    ...mapGetters({
      categories: "categories",
    }),
  },

  watch: {},

  mounted() {
    this.fetchCategoriesTree();
  },

  methods: {
    fetchCategoriesTree() {
      this.$store.dispatch("fetchCategoriesTree").then(() => {});
    },

    filterCategory(item) {
      this.$store.dispatch("setCategoryFilter", item);
    },

    openMenu(e) {
      e.preventDefault();
      var element = document.getElementById("sidebar-wrapper");
      element.classList.toggle("active");
    },

    closeMenu(e) {
      e.preventDefault();
      var element = document.getElementById("sidebar-wrapper");
      element.classList.toggle("active");
    },
  },

  data() {
    return {
      items: [
        {
          id: 1,
          title: "menu 1-1",
          children: [
            {
              id: 2,
              title: `Today's Deals`,
              link: `/today`,
              children: [],
            },
            {
              id: 3,
              title: `Shop By Department`,
              children: [
                {
                  id: 4,
                  title: `Amazon Music`,
                  link: `/music`,
                  children: [],
                },
                {
                  id: 5,
                  title: `CDs and Vinyl`,
                  link: `/cds`,
                  children: [],
                },
              ],
            },
          ],
        },

        {
          id: 6,
          title: "menu 1-2",
          children: [
            {
              id: 7,
              title: `Today's Deals`,
              link: `/today`,
              children: [
                {
                  id: 8,
                  title: `Amazon Music`,
                  link: `/music`,
                  children: [
                    {
                      id: 3,
                      title: `Shop By Department`,
                      children: [],
                    },
                  ],
                },
                {
                  id: 9,
                  title: `CDs and Vinyl`,
                  link: `/cds`,
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.sidebar {
  background: #f6f6f6;
}

#sidebar-wrapper {
  margin-right: -20%;
  right: 0;
  width: 20%;
  background: rgb(0, 0, 0);
  position: fixed;
  height: 100%;
  overflow-y: auto;
  z-index: 1000;
  transition: all 0.5s ease-in 0s;
  -webkit-transition: all 0.5s ease-in 0s;
  -moz-transition: all 0.5s ease-in 0s;
  -ms-transition: all 0.5s ease-in 0s;
  -o-transition: all 0.5s ease-in 0s;
}

.sidebar-nav {
  position: absolute;
  top: 0;
  width: 20%;
  list-style: none;
  margin: 0;
  padding: 0;
}

.sidebar-nav li {
  line-height: 50px;
  text-indent: 20px;
}

.sidebar-nav li a {
  color: #999999;
  display: block;
  text-decoration: none;
}

.sidebar-nav li a:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  text-decoration: none;
}

.sidebar-nav li a:active,
.sidebar-nav li a:focus {
  text-decoration: none;
}

.sidebar-nav > .sidebar-brand {
  height: 55px;
  line-height: 55px;
  font-size: 18px;
}

.sidebar-nav > .sidebar-brand a {
  color: #999999;
}

.sidebar-nav > .sidebar-brand a:hover {
  color: #fff;
  background: none;
}

#menu-toggle {
  top: 0;
  right: 0;
  position: fixed;
  z-index: 1;
}

#sidebar-wrapper.active {
  right: 20%;
  width: 20%;
  transition: all 0.5s ease-out 0s;
  -webkit-transition: all 0.5s ease-out 0s;
  -moz-transition: all 0.5s ease-out 0s;
  -ms-transition: all 0.5s ease-out 0s;
  -o-transition: all 0.5s ease-out 0s;
}

.toggle {
  margin: 5px 5px 0 0;
}
</style>


